import type { Theme } from '@mui/material/styles';
import spsTheme from './spsTheme';
import spsDarkTheme from './spsDarkTheme';
import defaultTheme from './defaultTheme';
import darkTheme from './darkTheme';
import type { ThemeMode } from './ThemeModeContext';

interface ThemePair {
  light: Theme;
  dark: Theme;
}

export const themeRegistry: Record<string, ThemePair> = {
  sps: { light: spsTheme, dark: spsDarkTheme },
};

export const resolveTenantTheme = (
  themeColor: string | null | undefined,
  mode: ThemeMode,
): Theme => {
  const pair = themeColor ? themeRegistry[themeColor.toLowerCase()] : undefined;
  if (pair) return mode === 'dark' ? pair.dark : pair.light;
  return mode === 'dark' ? darkTheme : defaultTheme;
};
